import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-icon-button");
import { style, globalStyle, fallbackVar } from '@vanilla-extract/css';
import { tokens } from '@paypalcorp/pp-react-theme';
import { textStyles } from '@paypalcorp/pp-react-text';
import { shimmerStyles } from '@paypalcorp/pp-react-shimmer';
import { contextColors, focusStyles } from '@paypalcorp/pp-react-utils';
const {
  focusOffsetElementStyles
} = focusStyles;
const containerWidth = '6rem';
const webkitSize = '0.0421875rem';
const iconButtonSmPadding = `calc(${tokens.space[100]} - 0.0625rem)`; // 7px padding

const iconButtonSize = `calc(${tokens.size.icon.sm} + 2 * ${tokens.space[150]})`;
const getCursorStyle = cursorStyle => {
  return {
    cursor: cursorStyle
  };
};
const fontNormal = style({
  ...textStyles.tagStyles,
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast)
}, 'icon-button_font');
const fontHover = {
  WebkitTextStrokeWidth: webkitSize,
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast)
};
export const container = style([fontNormal, {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: `${tokens.space[150]} 0`,
  width: containerWidth,
  wordWrap: 'break-word',
  border: 'none',
  backgroundColor: 'transparent',
  ':focus': {
    ...getCursorStyle('pointer'),
    outline: 'none'
  },
  ':hover': {
    ...getCursorStyle('pointer')
  }
}], 'icon-button_container');
globalStyle(`${container}:focus > div:first-of-type`, focusOffsetElementStyles);
globalStyle(`${container}:focus > span:last-of-type`, fontHover);
globalStyle(`${container}:hover > span:last-of-type`, fontHover);
globalStyle(`${container}:active > span:last-of-type`, fontHover);
globalStyle(`${container}:hover > div:first-of-type`, {
  background: fallbackVar(contextColors.hoverBack, tokens.color.tertiary.mainHover)
});
globalStyle(`${container}:active > div:first-of-type`, {
  background: fallbackVar(contextColors.activeBack, tokens.color.tertiary.mainActive)
});
export const processingContainer = style({
  ':hover': {
    ...getCursorStyle('default')
  }
}, 'icon-button_processing_container');
export const successContainer = style({
  ':hover': {
    ...getCursorStyle('default')
  }
}, 'icon-button_success_container');
globalStyle(`${successContainer}:hover > div:first-of-type`, {
  backgroundColor: fallbackVar(tokens.color.success.main)
});
const btnSize = style({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, 'icon-button_size');
export const sizeSm = style([btnSize, {
  padding: iconButtonSmPadding,
  width: tokens.size.circle.sm,
  height: tokens.size.circle.sm
}], 'icon-button_size_sm');
export const sizeXl = style([btnSize, {
  padding: tokens.space[200],
  width: tokens.size.tapTarget.lg,
  height: tokens.size.tapTarget.lg
}], 'icon-button_size_xl');
export const sizeLg = style([btnSize, {
  padding: tokens.space[150],
  width: tokens.size.tapTarget.default,
  height: tokens.size.tapTarget.default
}], 'icon-button_size_lg');
export const base = style({
  position: 'relative',
  ...getCursorStyle('pointer'),
  borderRadius: tokens.border.radius.interactive,
  border: 'none',
  backgroundColor: 'transparent',
  display: 'inline-flex',
  ':focus': focusOffsetElementStyles
}, 'icon-button_base');
export const primary = style({
  color: fallbackVar(contextColors.main, tokens.color.primary.contrast),
  background: fallbackVar(contextColors.background, tokens.color.primary.main),
  ':hover': {
    background: fallbackVar(contextColors.hoverBack, tokens.color.primary.mainHover)
  },
  ':active': {
    background: fallbackVar(contextColors.activeBack, tokens.color.primary.mainActive)
  }
}, 'icon-button_primary');
export const inverse = style({
  color: fallbackVar(contextColors.main, tokens.color.primary.contrast)
}, 'icon-button_inverse');
export const secondary = style({
  color: fallbackVar(contextColors.main, tokens.color.tertiary.main),
  background: fallbackVar(contextColors.background, tokens.color.tertiary.contrast),
  ':hover': {
    background: fallbackVar(contextColors.hoverBack, tokens.color.tertiary.mainHover)
  },
  ':active': {
    background: fallbackVar(contextColors.activeBack, tokens.color.tertiary.mainActive)
  }
}, 'icon-button_secondary');
export const secondaryInverse = style({
  background: fallbackVar(contextColors.background, tokens.color.primary.contrast),
  color: fallbackVar(contextColors.main, tokens.color.primary.main),
  ':hover': {
    background: fallbackVar(contextColors.hoverBack, tokens.color.primary.contrastHover)
  },
  ':active': {
    background: fallbackVar(contextColors.activeBack, tokens.color.primary.contrastActive)
  }
}, 'icon-button_secondary_inverse');
export const tertiary = style({
  color: fallbackVar(contextColors.main, tokens.color.background.mediumContrast),
  background: fallbackVar(contextColors.background),
  ':hover': {
    background: fallbackVar(contextColors.hoverBack, tokens.color.background.surfaceHover)
  },
  ':active': {
    background: fallbackVar(contextColors.activeBack, tokens.color.background.surfaceActive)
  }
}, 'icon-button_tertiary');
export const tertiaryInverse = style({
  color: fallbackVar(contextColors.main, tokens.color.overlay.contrast),
  background: fallbackVar(contextColors.background, tokens.color.overlay.main),
  ':hover': {
    background: fallbackVar(contextColors.hoverBack, tokens.color.overlay.mainHover)
  },
  ':active': {
    background: fallbackVar(contextColors.activeBack, tokens.color.overlay.mainActive)
  }
}, 'icon-button_tertiary_inverse');
export const icon = style({
  pointerEvents: 'none'
}, 'icon-button_icon');
globalStyle(`${base}:hover > ${icon}`, {
  color: fallbackVar(contextColors.hoverMain)
});
globalStyle(`${base}:active > ${icon}`, {
  color: fallbackVar(contextColors.activeMain)
});
export const shimmer = style({
  ...shimmerStyles.defaultStyles,
  borderRadius: tokens.border.radius.interactive,
  width: iconButtonSize,
  height: iconButtonSize
}, 'icon-button_shimmer');
export const shimmerSizeSm = style({
  width: tokens.size.circle.sm,
  height: tokens.size.circle.sm
}, 'icon-button_shimmer_size_sm');
export const shimmerSizeXl = style({
  width: tokens.size.circle.lg,
  height: tokens.size.circle.lg
}, 'icon-button_shimmer_size_xl');
export const shimmerSizeLg = style({
  width: tokens.size.circle.md,
  height: tokens.size.circle.md
}, 'icon-button_shimmer_size_lg');
export const loadingSpinner = style({
  margin: 0
}, 'icon-button_loading_spinner');
export const processingState = style({
  pointerEvents: 'none'
}, 'icon-button_processing_state');
export const successState = style({
  pointerEvents: 'none',
  backgroundColor: fallbackVar(contextColors.background, tokens.color.success.main),
  color: fallbackVar(contextColors.main, tokens.color.success.contrast),
  ':hover': {
    background: fallbackVar(contextColors.hoverBack, tokens.color.success.main),
    ...getCursorStyle('default')
  },
  ':active': {
    background: fallbackVar(contextColors.activeBack, tokens.color.success.main)
  }
}, 'icon-button_success_state');
export const label = style({
  display: '-webkit-box',
  textAlign: 'center',
  padding: `${tokens.space[100]} ${tokens.space[100]} 0 ${tokens.space[100]}`,
  width: 'inherit',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
}, 'icon-button_label');
export const smallSizeTapContainer = style({
  width: tokens.size.tapTarget.sm,
  height: tokens.size.tapTarget.sm,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'none',
  border: 'none',
  ...getCursorStyle('pointer'),
  ':focus': {
    outline: 'none'
  }
}, 'icon-button_small_tap_container');
globalStyle(`${smallSizeTapContainer}:focus > div:first-of-type:not(${successState}):not(${processingState})`, focusOffsetElementStyles);
globalStyle(`${smallSizeTapContainer}:hover > ${primary}:not(${successState}):not(${processingState})`, {
  background: fallbackVar(contextColors.hoverBack, tokens.color.primary.mainHover)
});
globalStyle(`${smallSizeTapContainer}:active > ${primary}:not(${successState}):not(${processingState})`, {
  background: fallbackVar(contextColors.activeBack, tokens.color.primary.mainActive)
});
globalStyle(`${smallSizeTapContainer}:hover > ${secondary}:not(${successState}):not(${processingState})`, {
  background: fallbackVar(contextColors.hoverBack, tokens.color.tertiary.mainHover)
});
globalStyle(`${smallSizeTapContainer}:active > ${secondary}:not(${successState}):not(${processingState})`, {
  background: fallbackVar(contextColors.activeBack, tokens.color.tertiary.mainActive)
});
globalStyle(`${smallSizeTapContainer}:hover > ${tertiary}:not(${successState}):not(${processingState})`, {
  background: fallbackVar(contextColors.hoverBack, tokens.color.background.surfaceHover)
});
globalStyle(`${smallSizeTapContainer}:active > ${tertiary}:not(${successState}):not(${processingState})`, {
  background: fallbackVar(contextColors.activeBack, tokens.color.background.surfaceActive)
});
globalStyle(`${smallSizeTapContainer}:hover > ${secondaryInverse}:not(${successState}):not(${processingState})`, {
  background: fallbackVar(contextColors.hoverBack, tokens.color.primary.contrastHover)
});
globalStyle(`${smallSizeTapContainer}:active > ${secondaryInverse}:not(${successState}):not(${processingState})`, {
  background: fallbackVar(contextColors.activeBack, tokens.color.primary.contrastActive)
});
globalStyle(`${smallSizeTapContainer}:hover > ${tertiaryInverse}:not(${successState}):not(${processingState})`, {
  background: fallbackVar(contextColors.hoverBack, tokens.color.overlay.mainHover)
});
globalStyle(`${smallSizeTapContainer}:active > ${tertiaryInverse}:not(${successState}):not(${processingState})`, {
  background: fallbackVar(contextColors.activeBack, tokens.color.overlay.mainActive)
});
__vanilla_filescope__.endFileScope();
